import React from 'react'
import { useStateValue } from '../../StateProvider';
import { getDefaultValue } from '../../utils';
import AddUserTalentModal from '../dialogs/AddUserTalentModal'

function WidgetAddDocument({ onVideosChanged, onContestParticipationChange }) {
    const [{ translations }] = useStateValue();
    const _t = (str) => {
        if (!translations) return str;
        var translate = translations.find((x) => x.key == str);

        if (translate) return getDefaultValue(translate);
        else return "#" + str;
    };


    return (
        <>
            <div className="kt-widget kfont" data-toggle="modal" data-target="#addUserTalentModal">
                <i className="fa fa-video"></i>
                {_t("Add Video")}
            </div>
            <AddUserTalentModal
                onVideosChanged={onVideosChanged}
                onContestParticipationChange={onContestParticipationChange}
            />
        </>

    )
}

export default WidgetAddDocument